<template>
  <section>
    <div class="add-addon-domain-modal">
      <div class="modal fade" tabindex="-1" role="dialog" :id="(id) ? id : 'access-video'" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Give BigScoots Access!</h5>
            </div>
            <div class="modal-body">
              <section v-if="!$parent.denied">
                <div class="row">
                  <div class="col-md-12">
                    <iframe v-if="host === 'GoDaddy'" class="w-100" height="350" src="https://www.youtube.com/embed/_gnGX8SwoaU" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    <iframe v-else class="w-100" height="350"  src="https://www.youtube.com/embed/ovPDNYxWTNc" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

                    <div class="row">
                      <div class="col-12">
                        <p class="text-center text-danger mt-4" style="font-size: 1.2rem;">
                          <i class="fa fa-exclamation-triangle mr-2" aria-hidden="true"></i>
                          <strong>When delegating access to BigScoots in your {{ host }} account, please be sure to use staff@bigscoots.com</strong>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 text-right">
                    <button type="button" class="btn btn-danger" @click="$parent.deniedAccess">Unable to grant access</button>
                    <button type="button" class="btn btn-success" data-dismiss="modal" @click="$parent.grantedAccess">Successfully granted access!</button>
                  </div>
                </div>
              </section>
              <section v-else>
                <p>
                  That's okay, please provide us with your login details and we'll take care of it for you.
                </p>
                <div class="row">
                  <div class="col-md-12 text-right">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" aria-label="Close">Proceed</button>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import copyButtonMixin from '@//mixins/copyButtonMixin';
  export default {
    name: "hostVideoModal",
    mixins: [copyButtonMixin],
    props: {
      id: {
        type: String,
        required: false
      },
      host: {
        type: String,
        required: true
      }
    }
  }
</script>

<style scoped>

</style>
